<app-generic-crud [genericCrud]="genericCRUD"></app-generic-crud>
